import React from "react";
import FieldCheck from "../../FieldCheck";
import {chunkArray} from "../../Utilities";

// This "chunk" solution appears simple, but ups render times significantly +300ms or more
// to chunk the array. Tried a CSS solution, but it runs into issues with fixed
// heights for unknowable #s of items.
export default class SplitToggles extends React.Component {
  makeChangeFunction = item => {
    return ({name, value}) => {
      this.props.onChange({
        name,
        value: {value: item._id, toggle: !value}
      });
    };
  };
  renderChunks(chunk) {
    const {cols, selectedItems, name, disabled} = this.props;
    const colWidth = 12 / cols;
    var chunks = [];
    for (var col = 0; col < cols; col++) {
      if (chunk[col]) {
        chunks.push(
          <div className={"col-xs-" + colWidth} key={chunk[col]._id}>
            <FieldCheck
              label={chunk[col].name}
              name={name}
              value={selectedItems.includes(chunk[col]._id)}
              onChange={this.makeChangeFunction(chunk[col])}
              checked={selectedItems.includes(chunk[col]._id)}
              disabled={disabled}
            />
          </div>
        );
      }
    }
    return chunks;
  }
  render() {
    const {items, cols} = this.props;
    return chunkArray(items, cols).map((chunk, index) => (
      <div className="row" key={index}>
        {this.renderChunks(chunk)}
      </div>
    ));
  }
}



// WEBPACK FOOTER //
// ./src/components/PermissionsToggles/SplitToggles/index.jsx